module.exports = __webpack_public_path__ + "img/采暖投用2倍图.3681056f.webp";